import translations from './translations.json';
export default { translations };
